<ng-container *ngIf="!invitationError; else error">
  <div class="invitation-link" >
    <h1>{{title}}</h1>
    <img src="../../../../assets/images/bask/people.svg" alt="Joint application invitation.">
    <p>Invitee must meet identity and eligibility requirements prior to being added as a joint owner.
      By successfully accepting this invite, and completing this application, you agree to become a joint owner,
      meaning you will have full permissions and access to the account. Please note that a joint owner cannot be
      removed without closing the shared account entirely.</p>
    <p>Application must be completed prior to</p>
    <strong>{{expireDate | date:'longDate'}}.</strong>
    <mat-divider></mat-divider>
    <button mat-flat-button class="primary-btn-action" color="primary" (click)="handleInvitation()" [class.spinner]="disableButton" [disabled]="disableButton">Accept Invitation</button>
  </div>
</ng-container>
<ng-template #error>
  <app-invitation-error></app-invitation-error>
</ng-template>
